<script setup lang="ts">
import bg1 from "@/assets/images/backgroundServices/1.png";
import bg2 from "@/assets/images/backgroundServices/2.png";
import bg3 from "@/assets/images/backgroundServices/3.png";

const services = [
	{
		title: "Consulting and Design", //"C&D",
		text: [
			"Consulting and Design to help sketch your ideas",
			// "Launch instantly & scale effortlessly",
			// "Collaborative development from anywhere",
			// "Multi-cloud, high-performance architecture",
		],

		link: "ConsultingAndDesign",
		bgImg: bg1,
	},
	{
		title: "Tailor made software", //"TMS",
		text: [
			"Tailor made software to help bring your ideas to reality",
			// "Launch instantly & scale effortlessly",
			// "Collaborative development from anywhere",
			// "Multi-cloud, high-performance architecture",
		],

		link: "TailorMadeSoftware",
		bgImg: bg2,
	},
	{
		title: "Development Acceleration Tools", //"DAT",
		text: [
			"Development Acceleration Tools to help optimize your build process",
			// "Launch instantly & scale effortlessly",
			// "Collaborative development from anywhere",
			// "Multi-cloud, high-performance architecture",
		],

		link: "https://marsengine.net/Features.html", // vodi na mars
		bgImg: bg3,
	},
];

const open = ref(0);

const isMobile = ref(false);
function onResize() {
	if (window.innerWidth <= 768) {
		console.log("is mobile true ");
		isMobile.value = true;
	} else {
		console.log("is mobile false ");
		isMobile.value = false;
	}
}

onMounted(() => {
	onResize();
	window.addEventListener("resize", onResize);
});
onUnmounted(() => {
	window.removeEventListener("resize", onResize);
});
</script>
<template>
	<div class="service-page slider-section">
		<TestSlideBg2 v-if="isMobile" :services="services" />

		<div v-else ref="sliderWrapper" class="wrapp-services">
			<one-service2
				v-for="(value, index) in services"
				:key="index"
				:service="value"
				:index="'index-' + index"
				:isOpen="index === open"
				@mouseenter="open = index"
			/>
		</div>
	</div>
</template>
<style lang="scss">
.service-page {
	box-sizing: border-box;
	// margin-top: 100px;
	padding-top: 100px;
	// height: calc(100vh - 100px);
	height: 100vh;
	.arrow {
		display: none;
	}
	.wrapp-services {
		display: flex;
		height: 100%;
	}
}

@media screen and (width <= 768px) {
	.service-page {
		// height: calc(100vh - 100px);
		// height: fit-content;
		position: relative;

		.arrow {
			display: initial;
			position: absolute;
			cursor: pointer; // top:calc(50% - 20px);
			top: calc(
				67px + 160px - 20px
			); // 321/2 = 160 min height of open content div, 67- padding bg div, 20 icon
		}
		.arrow.left {
			left: 15px;
		}
		.arrow.right {
			right: 15px;
		}
		.wrapp-services {
			height: calc(100% - 100px);
			width: 100%;
			overflow: auto;
			scroll-behavior: smooth;
			-ms-overflow-style: none; /* IE and Edge */
			scrollbar-width: none;
		}
	}
}
</style>
